import { render, staticRenderFns } from "./CountCorrectTableAdmin.vue?vue&type=template&id=30d12900&scoped=true"
import script from "./CountCorrectTableAdmin.vue?vue&type=script&lang=js"
export * from "./CountCorrectTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d12900",
  null
  
)

export default component.exports